import axios from '../axios'


//查找我的医院
export const myHospital = (data) => {
	return axios({
		url: '/api/hospital/my_hospital',
		method: 'get',
		params: data
	})
};

//创建流程申请单
export const addForm = (data) => {
	return axios({
		url: '/api/from/add_form',
		method: 'post',
		data: data
	})
};
//创建流程申请单
export const addReportFlow = (data) => {
	return axios({
		url: '/api/from/add_ReportFlow',
		method: 'post',
		data: data
	})
};

//修改流程申请单
export const updateForm = (data) => {
	return axios({
		url: '/api/from/update_form',
		method: 'post',
		data: data
	})
};

//查找流程申请单
export const selectForm = (data) => {
	return axios({
		url: '/api/from/select_form',
		method: 'post',
		params: data
	})
};

//增加流程
export const addWorkflow = (data) => {
	return axios({
		url: '/api/report/add_workflow',
		method: 'post',
		params: data
	})
};


//团队会诊
export const worksearchOpc = (data) => {
	return axios({
		url: '/api/report/team/report',
		method: 'get',
		params: data
	})
};

//团队会诊
export const teamReport = (data) => {
	return axios({
		url: '/api/report/team/report',
		method: 'get',
		params: data
	})
};


//我的任务
export const personReport = (data) => {
	return axios({
		url: '/api/report/person/report',
		method: 'get',
		params: data
	})
};

//查找流程
export const findByTaskId = (data) => {
	return axios({
		url: '/api/report/find_by_reportId',
		method: 'get',
		params: data
	})
};


//写报告
export const reportWrite = (data) => {
	return axios({
		url: '/api/report/write',
		method: 'post',
		data: data
	})
};

//审核通过
export const reportReviewer = (data) => {
	return axios({
		url: '/api/report/reviewer',
		method: 'post',
		data: data
	})
};

//写并且审核通过
export const reportWriteReview = (data) => {
	return axios({
		url: '/api/report/write_reviewer',
		method: 'post',
		data: data
	})
};

//报告退回
export const taskBack = (data) => {
	return axios({
		url: '/api/report/send_back',
		method: 'post',
		data: data
	})
};

//领取任务
export const taskClaim = (data) => {
	return axios({
		url: '/api/report/task/claim',
		method: 'post',
		params: data
	})
};

//作废重写
export const reportInvalid = (data) => {
	return axios({
		url: '/api/report/report/invalid',
		method: 'post',
		data: data
	})
};

//取消任务
export const delClaim = (data) => {
	return axios({
		url: '/api/report/del/claim',
		method: 'post',
		params: data
	})
};

//打印
export const reportPrint = (data) => {
	return axios({
		url: '/api/report/report/print',
		method: 'post',
		params: data
	})
};

//审核驳回
export const reviewerFail = (data) => {
	return axios({
		url: '/api/report/reviewer_fail',
		method: 'post',
		data: data
	})
};


//归档
export const reportArchive = (data) => {
	return axios({
		url: '/api/report/archive',
		method: 'post',
		params: data
	})
};

//保存并转发
export const saveForward = (data) => {
	return axios({
		url: '/api/report/task/save_forward',
		method: 'post',
		data: data
	})
};

//退回后修改报告
export const updateReport = (data) => {
	return axios({
		url: '/api/report/update_report',
		method: 'post',
		data: data
	})
};

export const selectList = (data) => {
	return axios({
		url: '/api/from/select_list',
		method: 'get',
		params: data
	})
};

//已归档已完成
export const allreport = (data) => {
	return axios({
		url: '/api/report/report',
		method: 'get',
		params: data
	})
};


//是否可以生成云胶片
export const findByHospitalIdAndDeviceType = (data) => {
	return axios({
		url: '/api/qr/findByHospitalIdAndDeviceType',
		method: 'get',
		params: data
	})
};

//生成云胶片
export const createQrReport = (data) => {
	return axios({
		url: '/api/report/createQrReport',
		method: 'get',
		params: data
	})
};

//院内云科室
export const addYun = (data) => {
	return axios({
		url: '/api/from/add_yun',
		method: 'post',
		data: data
	})
};


//加入疑难讨论
export const addDifficult = (data) => {
	return axios({
		url: '/api/difficult/add',
		method: 'post',
		data: data
	})
};

//疑难列表
export const findDifficult = (data) => {
	return axios({
		url: '/api/difficult/find',
		method: 'get',
		params: data
	})
};


//修改疑难信息
export const updateDifficult = (data) => {
	return axios({
		url: '/api/difficult/update',
		method: 'post',
		data: data
	})
};

//标记疑难
export const markDoubt = (data) => {
	return axios({
		url: '/api/report/mark_doubt',
		method: 'get',
		params: data
	})
};

//分配
export const reportDistribution = (data) => {
	return axios({
		url: '/api/report/task/distribution',
		method: 'post',
		data: data
	})
};




// WEBPACK FOOTER //
// ./src/http/moudules/form.js